export default "__VITE_ASSET__DBypv6s5__"